module.exports = __webpack_public_path__ + "img/upload.f4b7a94e.svg";